// This tells TypeScript: “If this function returns true, you can safely treat value as NonNullable<T> (i.e. not null or undefined).”
export function isNotNullOrUndefined<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

/**
 * Transforms the given label of a control manufacturer to its corresponding
 * standard value.
 * @param manufacturerLabel the label to be transformed
 * @returns the transformed label
 */
export function transformManufacturerName(manufacturerLabel: string | undefined) {
  if (manufacturerLabel) {
    switch (manufacturerLabel) {
      case "Hormann":
        return "Hörmann";
      case "MFZ":
        return "Marantec (MFZ)";
      default:
        return manufacturerLabel;
    }
  } else {
    return "";
  }
}
